import { Pagination as AntPagination } from "antd";
import { Icon } from "@iconify/react";

interface PaginationProps {
  page: number;
  limit: number;
  total: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, limit, total, onChange }: PaginationProps) {
  const start = total === 0 ? 0 : (page - 1) * limit + 1;
  const end = Math.min(total, page * limit);

  return (
    <div className="flex items-center justify-between border-t border-[#E5E7EB] px-4 py-3">
      <p className="text-xs text-[#75787B]">
        {total === 0 ? "No results" : `Showing ${start}-${end} of ${total}`}
      </p>
      <AntPagination
        current={page}
        pageSize={limit}
        total={total}
        onChange={onChange}
        showSizeChanger={false}
        className={[
          "[&_.ant-pagination-item]:!h-8 [&_.ant-pagination-item]:!w-8",
          "[&_.ant-pagination-item]:!flex [&_.ant-pagination-item]:!items-center [&_.ant-pagination-item]:!justify-center",
          "[&_.ant-pagination-item]:!rounded-md",
          "[&_.ant-pagination-item-active]:!border-none [&_.ant-pagination-item-active]:!bg-[#E4002B]/50",
          "[&_.ant-pagination-item-active_a]:!text-white [&_.ant-pagination-item_a]:!text-[#3A3D42]",
          "[&_.ant-pagination-item_a]:!flex [&_.ant-pagination-item_a]:!h-full [&_.ant-pagination-item_a]:!w-full [&_.ant-pagination-item_a]:!items-center [&_.ant-pagination-item_a]:!justify-center [&_.ant-pagination-item_a]:!leading-none",
          "[&_.ant-pagination-item_a]:!text-xs [&_.ant-pagination-item_a]:!font-medium",
          "[&_.ant-pagination-prev]:!flex [&_.ant-pagination-prev]:!h-8 [&_.ant-pagination-prev]:!w-8 [&_.ant-pagination-prev]:!items-center [&_.ant-pagination-prev]:!justify-center",
          "[&_.ant-pagination-next]:!flex [&_.ant-pagination-next]:!h-8 [&_.ant-pagination-next]:!w-8 [&_.ant-pagination-next]:!items-center [&_.ant-pagination-next]:!justify-center",
          "[&_.ant-pagination-item]:!transition-colors [&_.ant-pagination-item]:hover:!bg-[#FAFAFA]",
        ].join(" ")}
        itemRender={(_, type, originalElement) => {
          if (type === "prev") return <Icon icon="lucide:chevron-left" className="h-4 w-4 text-[#75787B]" />;
          if (type === "next") return <Icon icon="lucide:chevron-right" className="h-4 w-4 text-[#75787B]" />;
          return originalElement;
        }}
      />
    </div>
  );
}